<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      custom-class="recharge-dialog"
    >
    <div slot="title" class="dialog-header">
      <h3>选择充值套餐</h3>
      <p>购买积分，畅享论文助手全部功能</p>
    </div>

    <div class="products-container" v-loading="loading">
      <div 
        class="product-card" 
        :class="{ 
          'is-recommended': product.id === 2,
          'is-selected': selectedProductId === product.id
        }"
        v-for="product in products" 
        :key="product.id"
        @click="selectProduct(product)"
      >
        <div class="product-badge" v-if="product.id === 2">
          强推！毕业必备！
        </div>
        
        <div class="product-header">
          <h4 class="product-title">{{ product.title }}</h4>
        </div>
        
        <div class="product-body">
          <div class="product-price">
            <span class="price-amount">{{ (product.price / 100).toFixed(2) }}</span>
            <span class="price-unit">元</span>
            <span class="original-price" v-if="product.originalPrice">¥{{ (product.originalPrice / 100).toFixed(0) }}</span>
          </div>
          
          <div class="product-points">
            获得积分<span class="points-value">{{ product.points.toLocaleString() }}</span>
          </div>
          
          <div class="product-desc">{{ product.description }}</div>
        </div>

        <div class="product-footer">
          <el-button 
            class="buy-btn" 
            :class="{ 'btn-selected': selectedProductId === product.id }"
            @click="handleBuy(product)"
          >
            选择此方案
          </el-button>
        </div>
      </div>
    </div>

    <!-- 说明信息 -->
    <div class="notice-section">
      <div class="notice-title">温馨提示</div>
      <div class="notice-list">
        <div class="notice-item">
          <span class="notice-num">1</span>
          <span class="notice-text">抱团优惠（4人高级版）请<span class="link-text" @click="showContactModal">添加微信</span></span>
        </div>
        <div class="notice-item">
          <span class="notice-num">2</span>
          <span class="notice-text">充多少用多少，剩余积分无法退还</span>
        </div>
        <div class="notice-item">
          <span class="notice-num">3</span>
          <span class="notice-text">如积分未到账，积分消耗有问题，请<span class="link-text" @click="showContactModal">添加微信</span></span>
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- 支付方式选择模态框 -->
  <PaymentMethodModal 
    :visible.sync="showPaymentModal" 
    :product="selectedProduct"
  />
  </div>
</template>

<script>
import PaymentMethodModal from "@/components/PaymentMethodModal";

export default {
  name: 'RechargeModal',
  components: { PaymentMethodModal },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      products: [],
      loading: false,
      selectedProductId: null,
      showPaymentModal: false,
      selectedProduct: null
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadProducts()
      }
    },
    products(newVal) {
      // 产品加载完成后，默认选中专业版（id=2）
      if (newVal && newVal.length > 0) {
        const professionalProduct = newVal.find(p => p.id === 2)
        if (professionalProduct) {
          this.selectedProductId = professionalProduct.id
        }
      }
    }
  },
  methods: {
    async loadProducts() {
      this.loading = true
      try {
        const res = await this.request.get('/product')
        if (res.code === '200') {
          this.products = res.data || []
        }
      } catch (error) {
        console.error('获取商品列表失败:', error)
        this.$message.error('获取商品列表失败')
      } finally {
        this.loading = false
      }
    },
    selectProduct(product) {
      this.selectedProductId = product.id
    },
    handleBuy(product) {
      if (!this.selectedProductId) {
        this.$message.warning('请先选择一个套餐')
        return
      }
      this.selectedProduct = product
      this.showPaymentModal = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    showContactModal() {
      this.$emit('show-contact')
    }
  }
}
</script>

<style scoped>
/* 对话框标题 */
.dialog-header {
  text-align: center;
  padding: 8px 0;
}

.dialog-header h3 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.dialog-header p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* 产品容器 */
.products-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 10px 0;
  min-height: auto;
}

/* 产品卡片 */
.product-card {
  background: #fff;
  border: 2px solid #e5e7eb;
  border-radius: 0;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
}

.product-card:hover {
  border-color: #4f46e5;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.1);
}

/* 推荐卡片 */
.product-card.is-recommended {
  border-color: #6366f1;
}

/* 选中卡片 */
.product-card.is-selected {
  border: 2px solid #6366f1;
  background: #f5f3ff;
}

/* 产品徽章 */
.product-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #fff;
  padding: 4px 16px;
  border-radius: 0;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  z-index: 10;
}

/* 产品头部 */
.product-header {
  text-align: center;
  margin-bottom: 12px;
  padding-top: 4px;
}

.product-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

/* 产品主体 */
.product-body {
  flex: 1;
  text-align: center;
}

.product-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.price-amount {
  font-size: 32px;
  font-weight: 700;
  color: #ef4444;
  line-height: 1;
}

.price-unit {
  font-size: 16px;
  font-weight: 500;
  color: #6b7280;
}

.original-price {
  font-size: 14px;
  color: #9ca3af;
  text-decoration: line-through;
  margin-left: 8px;
}

.product-points {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 10px;
}

.points-value {
  font-weight: 600;
  color: rgb(79, 70, 229);
  margin-left: 4px;
}

.product-desc {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.5;
  margin-bottom: 20px;
}

/* 产品底部 */
.product-footer {
  margin-top: auto;
}

.buy-btn {
  width: 100%;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 0;
  background: #f3f4f6;
  border-color: #e5e7eb;
  color: #6366f1;
}

.buy-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
  color: #4f46e5;
}

/* 选中状态的按钮 */
.buy-btn.btn-selected {
  background: #6366f1;
  border-color: #6366f1;
  color: #fff;
}

.buy-btn.btn-selected:hover {
  background: #4f46e5;
  border-color: #4f46e5;
}

/* 响应式 */
@media (max-width: 1024px) {
  .products-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .products-container {
    grid-template-columns: 1fr;
  }
}

/* 说明区域 */
.notice-section {
  margin-top: 20px;
  padding: 16px 20px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.notice-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.notice-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.notice-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;
}

.notice-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: #6366f1;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 1px;
}

.notice-text {
  flex: 1;
}

.link-text {
  color: #6366f1;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
}

.link-text:hover {
  color: #4f46e5;
}
</style>

<style>
/* 全局样式 - 调整对话框样式 */
.recharge-dialog {
  border-radius: 0;
}

.recharge-dialog .el-dialog__header {
  padding: 24px 24px 0;
  border-bottom: none;
}

.recharge-dialog .el-dialog__body {
  padding: 0 24px 24px;
}

.recharge-dialog .el-dialog__title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
}
</style>
